"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const colors_1 = require("../styles/colors");
const ProgressBarThin = ({ progress, barPropStyle, progressPropStyle }) => {
    const barStyle = Object.assign({ height: 2, width: 240, overflow: 'hidden', backgroundColor: colors_1.cloud }, barPropStyle);
    const progressStyle = Object.assign({ backgroundColor: colors_1.turquoise, width: progress > 3 ? `${progress}%` : 8, height: '100%' }, progressPropStyle);
    return (React.createElement("div", { style: barStyle },
        React.createElement("div", { style: progressStyle })));
};
exports.default = ProgressBarThin;
